import { Component, Input, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import * as luxon from 'luxon';

@Component({
  selector: 'fgb-ecash-button',
  templateUrl: './ecash-button.component.html',
  styleUrls: ['./ecash-button.component.scss'],
})
export class EcashButtonComponent implements OnInit {
  @Input() isMemberCard: boolean = false;
  @Input() cardRouteURL: string = '/ecash';
  cardToken$: Observable<CardToken | undefined>;
  nonDefaultCardTokens$: Observable<CardToken[]>;

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }

  isExpiried(expiryDate: string) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate);
    return now > expiriedDate;
  }
}
